import { render } from "./deleteTable.vue?vue&type=template&id=78b5a687"
import script from "./deleteTable.vue?vue&type=script&lang=js"
export * from "./deleteTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__